import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Combobox } from "@similarweb/ui-components";

import { useComboboxSearch } from "../../../hooks/useComboboxSearch";
import type { DynamicComboboxFilterOption } from "../../../types/filterOptions";

type SearchableComboboxContentProps = {
    isOpen: boolean;
    options: readonly DynamicComboboxFilterOption[];
    searchDataAutomation: string;
    renderOption: (option: DynamicComboboxFilterOption) => ReactNode;
};

const SearchableComboboxContent = ({
    isOpen,
    options,
    searchDataAutomation,
    renderOption,
}: SearchableComboboxContentProps) => {
    const { translate } = useTranslate();

    const { searchTerm, onSearchTermChange, filteredOptions } = useComboboxSearch(options, isOpen);

    return (
        <>
            <Combobox.SearchInput
                data-automation={searchDataAutomation}
                value={searchTerm}
                onChange={onSearchTermChange}
                placeholder={translate("common.placeholder.search")}
            />

            <Combobox.Content
                emptyState={<Combobox.OptionLabel>{translate("dropdown.no.results")}</Combobox.OptionLabel>}
            >
                {filteredOptions.map(renderOption)}
            </Combobox.Content>
        </>
    );
};

export default SearchableComboboxContent;
